import React, { useEffect } from 'react';
import './BrevoForm.css';

const BrevoForm = () => {
  useEffect(() => {
    // 1. Set global variables required by Brevo script
    window.REQUIRED_CODE_ERROR_MESSAGE = 'Please choose a country code';
    window.LOCALE = 'en';
    window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";
    window.REQUIRED_ERROR_MESSAGE = "This field cannot be left blank. ";
    window.GENERIC_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";
    window.translation = {
      common: {
        selectedList: '{quantity} list selected',
        selectedLists: '{quantity} lists selected',
        selectedOption: '{quantity} selected',
        selectedOptions: '{quantity} selected',
      }
    };
    window.AUTOHIDE = Boolean(0);

    // 2. Define Captcha Callback
    window.handleCaptchaResponse = () => {
      const event = new Event('captchaChange');
      const captchaElement = document.getElementById('sib-captcha');
      if (captchaElement) {
        captchaElement.dispatchEvent(event);
      }
      window.grecaptcha = window.turnstile;
    };

    // 3. Load External Scripts and Styles
    // CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://sibforms.com/forms/end-form/build/sib-styles.css';
    document.head.appendChild(link);

    // Main Brevo Script
    const scriptMain = document.createElement('script');
    scriptMain.src = "https://sibforms.com/forms/end-form/build/main.js";
    scriptMain.defer = true;
    document.body.appendChild(scriptMain);

    // Cloudflare Turnstile Script (Replaces Google reCAPTCHA)
    const scriptCaptcha = document.createElement('script');
    scriptCaptcha.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    scriptCaptcha.async = true;
    scriptCaptcha.defer = true;
    document.body.appendChild(scriptCaptcha);

    return () => {
      // Cleanup
      document.head.removeChild(link);
      document.body.removeChild(scriptMain);
      document.body.removeChild(scriptCaptcha);
      // Clean up globals if necessary
      delete window.handleCaptchaResponse;
    };
  }, []);

  // HTML content reflecting the new form structure and Cloudflare Turnstile
  const formHtml = `
    <div class="sib-form" style="text-align: center; background-color: transparent;">
      <div id="sib-form-container" class="sib-form-container">
        <div id="error-message" class="sib-form-message-panel" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;max-width:540px;">
          <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
            <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
              <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-12.536-28-28-28z" />
            </svg>
            <span class="sib-form-message-panel__inner-text">
              Your form could not be saved. Please try again.
            </span>
          </div>
        </div>
        <div></div>
        <div id="success-message" class="sib-form-message-panel" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#085229; background-color:#e7faf0; border-radius:3px; border-color:#13ce66;max-width:540px;">
          <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
            <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
              <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
            </svg>
            <span class="sib-form-message-panel__inner-text">
              Thank you we got it!
            </span>
          </div>
        </div>
        <div></div>
        <div id="sib-container" class="sib-container--large sib-container--vertical" style="text-align:center; background-color:rgba(239,242,247,1); max-width:540px; border-radius:14px; border-width:0px; border-color:#C0CCD9; border-style:solid; direction:ltr">
          <form id="sib-form" method="POST" action="https://1d48d74a.sibforms.com/serve/MUIFADNwRLNE1ocewLrFlqJFIoW_4vv-sWM0Gw34m1WcTTbh8d4wJxgmijujdqXFqBbYXpRj25lrIHZQ2IRpgrGbAW1XLuvni_N92hNjRGtCvDI_SoJMO9S2tQdLCTgoyisk3CrzUMj0kGE40_bKdx1yZNqpPiTsPQyRaFLeAc38eWLcnGXvV_dr_A59c6Dfo_uuxng4TA4YZ7RP" data-type="subscription">
            <div style="padding: 8px 0;">
              <div class="sib-form-block" style="font-size:32px; text-align:left; font-weight:700; font-family:Helvetica, sans-serif; color:#2571ab; background-color:transparent; text-align:left">
                <p>Like to know more?</p>
              </div>
            </div>
            <div style="padding: 8px 0;">
              <div class="sib-form-block" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#2571ab; background-color:transparent; text-align:left">
                <div class="sib-text-form-block">
                  <p>If you would like to know more about building high trust Partnership relationships or you have some feedback for us, please let us know.</p>
                </div>
              </div>
            </div>
            <div style="padding: 8px 0;">
              <div class="sib-input sib-form-block">
                <div class="form__entry entry_block">
                  <div class="form__label-row ">
                    <label class="entry__label" style="font-weight: 700; text-align:left; font-size:16px; text-align:left; font-weight:700; font-family:Helvetica, sans-serif; color:#2571ab;" for="FIRSTNAME" data-required="*">Your Name</label>
                    <div class="entry__field">
                      <input class="input " maxlength="200" type="text" id="FIRSTNAME" name="FIRSTNAME" autocomplete="off" data-required="true" required />
                    </div>
                  </div>
                  <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;"></label>
                </div>
              </div>
            </div>
            <div style="padding: 8px 0;">
              <div class="sib-input sib-form-block">
                <div class="form__entry entry_block">
                  <div class="form__label-row ">
                    <label class="entry__label" style="font-weight: 700; text-align:left; font-size:16px; text-align:left; font-weight:700; font-family:Helvetica, sans-serif; color:#2571ab;" for="EMAIL" data-required="*">Email</label>
                    <div class="entry__field">
                      <input class="input " type="text" id="EMAIL" name="EMAIL" autocomplete="off" placeholder="Email" data-required="true" required />
                    </div>
                  </div>
                  <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;"></label>
                </div>
              </div>
            </div>
            <div style="padding: 8px 0;">
              <div class="sib-input sib-form-block">
                <div class="form__entry entry_block">
                  <div class="form__label-row ">
                    <label class="entry__label" style="font-weight: 700; text-align:left; font-size:16px; text-align:left; font-weight:700; font-family:Helvetica, sans-serif; color:#2571ab;" for="COMMENTS">Comments/Feedback</label>
                    <div class="entry__field">
                      <textarea rows="2" class="input " maxlength="500" id="COMMENTS" name="COMMENTS" autocomplete="off"></textarea>
                    </div>
                  </div>
                  <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;"></label>
                  <label class="entry__specification" style="font-size:12px; text-align:left; font-family:Helvetica, sans-serif; color:#8390A4; text-align:left">
                    We&#039;d love to hear from you!
                  </label>
                </div>
              </div>
            </div>
            <div style="padding: 8px 0;">
              <div class="sib-captcha sib-form-block">
                <div class="form__entry entry_block">
                  <div class="form__label-row ">
                    <div class="cf-turnstile g-recaptcha" data-sitekey="0x4AAAAAACWQNqx_wpv-Qqho" id="sib-captcha" data-callback="handleCaptchaResponse" data-language="en"></div>
                  </div>
                  <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;"></label>
                </div>
              </div>
            </div>
            <div style="padding: 8px 0;">
              <div class="sib-form-block" style="text-align: center">
                <button class="sib-form-block__button sib-form-block__button-with-loader" style="font-size:25px; text-align:center; font-weight:700; font-family:Helvetica, sans-serif; color:#FFFFFF; background-color:#0095da; border-radius:15px; border-width:0px;" form="sib-form" type="submit">
                  <svg class="icon clickable__icon progress-indicator__icon sib-hide-loader-icon" viewBox="0 0 512 512" style="">
                    <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
                  </svg>
                  Submit
                </button>
              </div>
            </div>
            <input type="text" name="email_address_check" value="" class="input--hidden">
            <input type="hidden" name="locale" value="en">
          </form>
        </div>
      </div>
    </div>
  `;

  return <div dangerouslySetInnerHTML={{ __html: formHtml }} />;
};

export default BrevoForm;